/**
 * @generated SignedSource<<18bcbcb83c5ea4dff2cddc5f86dc7a4b>>
 * @relayHash 833a199280e17468b888b75415571623
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 757c41bf66d4b23344db601f044d5ddb1c4983731abd0744dfca530decb91fa2

import type { ConcreteRequest } from 'relay-runtime';
export type WebPanelLocationQuery$variables = {
  contentId?: string | null | undefined;
  location?: string | null | undefined;
  spaceKey?: string | null | undefined;
};
export type WebPanelLocationQuery$data = {
  readonly webPanels: ReadonlyArray<{
    readonly completeKey: string | null | undefined;
    readonly html: string | null | undefined;
    readonly label: string | null | undefined;
    readonly location: string | null | undefined;
    readonly moduleKey: string | null | undefined;
    readonly name: string | null | undefined;
    readonly weight: number | null | undefined;
  } | null | undefined> | null | undefined;
};
export type WebPanelLocationQuery = {
  response: WebPanelLocationQuery$data;
  variables: WebPanelLocationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "location"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "location",
        "variableName": "location"
      }
    ],
    "concreteType": "WebPanel",
    "kind": "LinkedField",
    "name": "webPanels",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "moduleKey"
      },
      {
        "kind": "ScalarField",
        "name": "completeKey"
      },
      {
        "kind": "ScalarField",
        "name": "html"
      },
      {
        "kind": "ScalarField",
        "name": "location"
      },
      {
        "kind": "ScalarField",
        "name": "label"
      },
      {
        "kind": "ScalarField",
        "name": "weight"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "WebPanelLocationQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "WebPanelLocationQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "833a199280e17468b888b75415571623",
    "id": "757c41bf66d4b23344db601f044d5ddb1c4983731abd0744dfca530decb91fa2",
    "metadata": {},
    "name": "WebPanelLocationQuery",
    "operationKind": "query",
    "text": "query WebPanelLocationQuery($location:String,$contentId:ID,$spaceKey:String){webPanels(location:$location,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
  }
};
})();

(node as any).hash = "d375ecd281e94a7575edd0ac7360eb54";

export default node;
